import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import moment from 'moment';
import {
  getProfileUser,
  getUserSubscriptionHistory,
  getUserCarPosts,
  getListingStats,
  adminSetPassword,
} from '../../../actions/homeAction';

const card = {
  background: '#fff',
  borderRadius: 8,
  padding: '1.25rem 1.5rem',
  marginBottom: '1.5rem',
  boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
};
const h = { fontWeight: 600, color: '#1b2a4e', marginBottom: '1rem' };
const statBox = {
  flex: 1,
  textAlign: 'center',
  padding: '1rem',
  borderRadius: 8,
  background: '#f6f8fc',
  margin: '0 0.5rem',
};

const fmt = (d) => (d ? moment(d).format('DD/MM/YYYY , hh:mm A') : '—');

const ProfileView = () => {
  const dispatch = useDispatch();
  const { userId, businessId } = useParams();

  const [pwd, setPwd] = useState('');

  useEffect(() => {
    if (userId) {
      dispatch(getProfileUser(userId));
      dispatch(getUserSubscriptionHistory(userId));
      dispatch(getUserCarPosts(userId));
    }
    if (businessId) dispatch(getListingStats(businessId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, businessId]);

  const home = useSelector((state) => state.home);
  const pu = home?.profileUser;
  const user =
    pu?.response?.userList?.[0] ||
    (Array.isArray(pu?.response) ? pu.response[0] : null) ||
    pu?.response ||
    {};

  const us = home?.userSubs;
  const subs = Array.isArray(us)
    ? us
    : us?.subscriptionOrders ||
      us?.orders ||
      us?.subscriptions ||
      us?.data ||
      (Array.isArray(us?.response) ? us.response : us?.response?.data) ||
      [];

  const cp = home?.userCarPosts;
  const carPosts = Array.isArray(cp)
    ? cp
    : (Array.isArray(cp?.response) ? cp.response : cp?.response?.data) ||
      cp?.data ||
      [];

  const stats = home?.listingStats?.response || { views: 0, contacts: 0 };

  const onChangePassword = () => {
    if (!pwd || pwd.length < 6) {
      Swal.fire({
        title: 'Password must be at least 6 characters',
        icon: 'warning',
        confirmButtonColor: '#3ab1f7',
      });
      return;
    }
    dispatch(
      adminSetPassword(userId, pwd, () => {
        setPwd('');
        Swal.fire({
          title: 'Password updated',
          icon: 'success',
          confirmButtonColor: '#3ab1f7',
        });
      })
    );
  };

  const row = (label, value) => (
    <div style={{ display: 'flex', padding: '0.4rem 0', borderBottom: '1px solid #f0f0f0' }}>
      <div style={{ width: 200, color: '#7b8aa5' }}>{label}</div>
      <div style={{ fontWeight: 500 }}>{value || '—'}</div>
    </div>
  );

  return (
    <div className="pcoded-inner-content">
      <div className="main-body">
        <div className="page-wrapper">
          <div className="row">
            <div className="col-sm-12">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                <h4 style={{ fontWeight: 600 }}>
                  {businessId ? 'Service Provider Profile' : 'User Profile'}
                </h4>
                <Link to={businessId ? '/service-provider' : '/user'} className="btn btn-sm btn-outline-dark">
                  Back
                </Link>
              </div>

              {/* Analytics (service providers only) */}
              {businessId && (
                <div style={card}>
                  <div style={h}>Listing Engagement</div>
                  <div style={{ display: 'flex' }}>
                    <div style={statBox}>
                      <div style={{ fontSize: '1.8rem', fontWeight: 700, color: '#3ab1f7' }}>{stats.views || 0}</div>
                      <div style={{ color: '#7b8aa5' }}>Profile Views</div>
                    </div>
                    <div style={statBox}>
                      <div style={{ fontSize: '1.8rem', fontWeight: 700, color: '#28a745' }}>{stats.contacts || 0}</div>
                      <div style={{ color: '#7b8aa5' }}>Contact Clicks (call / WhatsApp)</div>
                    </div>
                  </div>
                  <div style={{ color: '#9aa7bd', fontSize: '0.8rem', marginTop: '0.75rem' }}>
                    How many people opened this provider's page and tapped to contact them.
                  </div>
                </div>
              )}

              {/* Basic info */}
              <div style={card}>
                <div style={h}>Account Details</div>
                {row('User Name', user.username)}
                {row('Phone', `${user.mobileNumberCountryCode || ''} ${user.mobileNumber || ''}`)}
                {row('Mobile Verified', user.mobileVerified ? 'Verified' : 'Not verified')}
                {row('Registered', fmt(user.createdAt))}
                {row('Status', user.status)}
              </div>

              {/* Membership history */}
              <div style={card}>
                <div style={h}>Membership / Package History</div>
                <div className="dt-responsive table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Plan</th>
                        <th>Amount</th>
                        <th>Start</th>
                        <th>Expiry</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {subs && subs.length ? (
                        subs.map((s, i) => {
                          const amt = s.amount != null ? s.amount : s.packageAmount;
                          return (
                          <tr key={i}>
                            <td>{s.subscriptionPlan || s.packageName || s.name || '—'}</td>
                            <td>{amt != null ? `${amt} KWD` : '—'}</td>
                            <td>{fmt(s.startDate || s.createdAt)}</td>
                            <td>{fmt(s.expiry || s.expiryDate || s.endDate)}</td>
                            <td>{s.active ? 'Active' : 'Expired'}</td>
                          </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="5" style={{ textAlign: 'center', color: '#9aa7bd' }}>
                            No package purchases yet.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Car for sale posts */}
              <div style={card}>
                <div style={h}>Car-for-Sale Posts</div>
                <div className="dt-responsive table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Title</th>
                        <th>Brand / Model</th>
                        <th>Price</th>
                        <th>Status</th>
                        <th>Posted</th>
                      </tr>
                    </thead>
                    <tbody>
                      {carPosts && carPosts.length ? (
                        carPosts.map((c, i) => {
                          const brandName =
                            (c.brand && (c.brand.name || c.brand.nameAr)) ||
                            c.brandName ||
                            '';
                          const modelName =
                            (c.modelYear && c.modelYear.modelYear) ||
                            c.model ||
                            c.modelName ||
                            '';
                          return (
                          <tr key={i}>
                            <td>{c.title || c.name || brandName || '—'}</td>
                            <td>{`${brandName} ${modelName}`.trim() || '—'}</td>
                            <td>{c.price != null ? `${c.price} KWD` : '—'}</td>
                            <td>{c.status || (c.active ? 'Active' : '—')}</td>
                            <td>{fmt(c.createdAt)}</td>
                          </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="5" style={{ textAlign: 'center', color: '#9aa7bd' }}>
                            No car-for-sale posts.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Change password */}
              <div style={card}>
                <div style={h}>Change Password</div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', maxWidth: 480 }}>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="New password"
                    value={pwd}
                    onChange={(e) => setPwd(e.target.value)}
                  />
                  <button className="btn btn-inverse" style={{ whiteSpace: 'nowrap' }} onClick={onChangePassword}>
                    Update
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileView;
